import { render, staticRenderFns } from "./LoadingTemplate.vue?vue&type=template&id=c4f5e576&scoped=true"
import script from "./LoadingTemplate.vue?vue&type=script&lang=ts"
export * from "./LoadingTemplate.vue?vue&type=script&lang=ts"
import style0 from "./LoadingTemplate.vue?vue&type=style&index=0&id=c4f5e576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f5e576",
  null
  
)

export default component.exports